import { defineStore, mapActions } from "pinia";
import { useAxiosStore } from "js/stores/axiosStore.js";

export const useRecommendationStore = defineStore("recommendationStore", {
    state: () => {
        return {
            recommendations: [],
            durations: [],
            selectedStyle: null,
            selectedMonths: null,
            selectedDuration: null,
            selectedRegion: null,
            mode: null,
        };
    },
    actions: {
        async loadTripIdeas(params) {
            return this.fetch("/api/ai/trip-ideas", params);
        },
        async loadBucketListIdeas(bucketListId, reset) {
            const url =
                `/api/ai/bucket-list-ideas/${bucketListId}` +
                (reset ? "?reset" : "");
            return this.fetch(url);
        },
        ...mapActions(useAxiosStore, ["fetch"]),
    },
});
